<template>

  <router-view/>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: 'App',
  watch: {
      $route(to) {
          document.title = to.meta.title || 'Andamento da Obra';
      },
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapGetters(["datas"]),
  },
   methods:{
     ...mapActions(["fetchData"]),
  }
};
</script>
<style>
#app {
  font-family: 'Noto Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: rgb(41 44 51);
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
body .text-white {
    color: #fff !important;
}

</style>
